import { Card, LearnMoreLink, Text } from '@ui/themed';
import type { PropsWithChildren } from 'react';

export function OptionsCard({
  title,
  subtitle,
  learnMoreUrl,
  children,
}: PropsWithChildren<{
  title: string;
  subtitle?: string;
  learnMoreUrl?: string;
}>) {
  return (
    <Card initialCollapsed>
      <Card.Header headingLevel="h2" collapsible>
        {title}
      </Card.Header>
      {(subtitle || learnMoreUrl) && (
        <Text size="sm" variant="secondary">
          {subtitle}
          {learnMoreUrl && (
            <>
              {' '}
              <LearnMoreLink link={learnMoreUrl} />
            </>
          )}
        </Text>
      )}
      <Card.Body>
        <div className="flex flex-col gap-4">{children}</div>
      </Card.Body>
    </Card>
  );
}
